import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { CircularProgress, Hidden } from '@mui/material';
import logo from "../../assets/img/Fronic_logo_black.png"
import { useNavigate } from "react-router-dom"
import { saveObject, toastError, toastSuccess } from '../../utils';
import LoginFormValidate from './LoginFormValidate';
import { adminLogin } from "./actions";
import loginScreen from "../../assets/img/loginScreen.jpg"
import FullScreenLoader from '../Common/FullScreenLoader';

export default function Login() {
    const navigate = useNavigate();
    const [user, setUser] = useState({
        email: '',
        password: ''
    })
    const [errors, setErrors] = useState({})
    const [imageLoader, setImageLoader] = useState(true);
    const [loginLoader, setLoginLoader] = useState(false)

    // useEffect(() => {
    //     const image = 'https://source.unsplash.com/random';
    //     console.log(image, "https://source.unsplash.com/random")

    //     axios.get('https://source.unsplash.com/random').then(res => {
    //         console.log(res)
    //     }).catch(err => {

    //     })

    // }, [])

    const onChangeHandler = ({ target: { value = '', name = '' } }) => {
        setUser({ ...user, [name]: value })
        setErrors({ ...errors, [name]: '' })
    }

    const onSubmit = (e) => {
        e.preventDefault()
        if (loginLoader) return
        const { errors, isValid } = LoginFormValidate(user)
        setErrors(errors);
        if (isValid) {
            setLoginLoader(true)
            adminLogin(user).then((res) => {
                saveObject('auth', res.token)
                toastSuccess(res.message || 'Login successful');
                setLoginLoader(false)
                return navigate('/')
            }).catch((err) => {
                setLoginLoader(false)
                toastError(err?.message || 'Something went wrong');
            })
        }
    }

    const LoaderStyle = {
        height: "100%",
        overflow: "hidden"
    }

    return (
        <>
            <FullScreenLoader open={loginLoader} />
            <Grid container component="main" sx={{ height: '100vh' }} className="login-container">
                <CssBaseline />
                <Hidden only={['xs']}>
                    <Grid item xs={false} sm={4} md={7} sx={{ width: '100%', height: '100vh' }}>
                        <img
                            src={loginScreen}
                            alt=''
                            onLoad={() => setImageLoader(false)}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Grid>
                </Hidden>
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <div style={{
                        margin: '64px 32px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <div className="login-logo-div">
                            <img src={logo} alt="logo" />
                        </div>
                        <form
                            className="form-container"
                            onSubmit={onSubmit}
                            noValidate
                            style={{ width: '100%', marginTop: '8px' }}
                        >
                            <TextField
                                type="text"
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                error={errors && errors.email ? !!errors.email : !!''}
                                value={user.email}
                                onChange={onChangeHandler}
                                autoComplete="email"
                                autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                error={errors && errors.password ? !!errors.password : !!''}
                                value={user.password}
                                onChange={onChangeHandler}
                                autoComplete="current-password"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{ margin: '24px 0 16px' }}
                                style={{ height: 50 }}
                                onClick={onSubmit}
                            >
                                Login
                            </Button>
                            <Grid container>
                            </Grid>
                        </form>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}